export default __webpack_public_path__ + "static/media/hero_6.6b743ca2.png";